import { stylesheet } from 'typestyle';
import { colors, font, spacers } from '../../assets/styles';

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: spacers.pageMargin,
    paddingTop: '60px',
    paddingBottom: '40px',
  },
  header: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '-0.15px',
    textAlign: 'center',
    marginBottom: '6px',
  },
  subHeader: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    // marginBottom: 40,
    paddingLeft: 12,
    paddingRight: 12,
    minHeight: 75,
  },
  pretext: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
  },
  time: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '-0.18px',
    marginBottom: 60,
  },
  button: {
    fontSize: '16px !important',
    fontWeight: font.weight.bold,
    letterSpacing: '-.12px',
  },
});

export default styles;
